export const name = 'Output'

export const Commands = {}

export const Css = '/css/parts/ViewletOutput.css'

export * from './ViewletOutput.js'
